const baseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8001/v1';

export const getData = (userId: number): string => {
    return `${baseUrl}/data/${userId}`;
};

export const APIS_METHOD = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE',
    PATCH: 'PATCH'
};

export const APIS_ENDPOINTS = {
    LOGIN: '/auth/login/',
    FORGET_PASSWORD: '/account/forgot-password',
    VERIFY_EMAIL: '/auth/verify-email',
    RESEND_EMAIL_OTP: '/account/resend-otp',
    CHANGE_PASSWORD: 'account/change-password',
    ACCOUNT_RESEND_OTP: 'account/resend-email-otp',
    RESET_PASSWORD: '/account/reset-password',
    SIGNUP: 'auth/signup',
    CHECK_EMAIL: 'auth/email-exists',
    VERIFY_CODE: 'account/verify-code',
    AUTH_LOGOUT: 'auth/logout',
    TOKEN_REFRESH: '/api/token/refresh/',
    VERIFY_OTP: 'account/verify-otp',
    RESEND_OTP: 'account/forgot-resend-otp/',
    GOOGLE_SIGN_IN: '/auth/social-login/',
    ANNUAL_REVENUE: '/common/annual-revenue/',
    INDUSTRY_TYPE: '/common/industry/',
    COMPANY_SIZE: '/common/company-size/',
    COMPANY_PROFILE: '/account/profile',
    ADMIN_USERS_LIST: '/sbr2th_admin/user-management',
    TIERS: '/sbr2th_admin/all-tier/',
    USER_PROFILE_ACTION: '/sbr2th_admin/account-verify/',
    ADD_TIER_ACTION: '/sbr2th_admin/tier/',
    ADMIN_TIERS_LIST: '/sbr2th_admin/tier',
    UPDATE_TIER_ACTION: '/sbr2th_admin/tier',
    ADMIN_DASHBOARD_ANALYTICS: '/sbr2th_admin/admin-dashboard/',
    AI_UPLOAD_DOC: '/ai/chat/',
    JOB_SAVED_DRAFT: '/job/draft_job/',
    // Job Description Chat endpoints (separated by page)
    JOB_DESCRIPTION_CHAT: '/ai/job-description-chat/',
    IDEALIZED_CANDIDATE_CHAT: '/ai/idealized-candidate-chat/',
    IDEALIZED_CANDIDATE_MOVE_SUGGESTION: '/ai/idealized-candidate-chat/move-suggestion/',
    // Pricing endpoints
    TIER_DETAILS: '/sbr2th_admin/tier-details/',
    SELECT_PLAN: '/sbr2th_admin/change-plan/',
    SIGNUP_PLAN_SELECTION: '/sbr2th_admin/signup-plan-selection/',
    CONTACT_SALES: '/sbr2th_admin/contact-sales/',
    ENHANCED_CONTACT_SALES: '/sbr2th_admin/enhanced-contact-sales/',
    CONTACT_US_TO_UPGRADE: '/sbr2th_admin/contact-us-to-upgrade/',
    DELETE_USER: '/sbr2th_admin/user-management',
    JOB_FIELD_SUGGESTION: '/job/add-field-suggestion/',
    FORAGER_PERSON_CONTACT: '/ai/forager-person-contact/contacts/',
    COOKIE_PREFERENCES: '/account/cookie-preferences/',
    // Analytics endpoints
    ANALYTICS_TRACK_EVENT: '/analytics/track-event/',
    ANALYTICS_TRACK_PAGE_VIEW: '/analytics/track-page-view/',
    ANALYTICS_TRACK_SCROLL_DEPTH: '/analytics/track-scroll-depth/',
    ANALYTICS_START_SESSION: '/analytics/start-session/',
    ANALYTICS_END_SESSION: '/analytics/end-session/',
    ANALYTICS_CHECK_STUCK: '/analytics/check-stuck/',
    // Admin analytics dashboard endpoints
    ANALYTICS_DASHBOARD_OVERALL: '/analytics/dashboard/overall/',
    ANALYTICS_DASHBOARD_USERS: '/analytics/dashboard/users/',
    ANALYTICS_DASHBOARD_FLOWS: '/analytics/dashboard/flows/',
};

export const API_ERROR = {
    FOUR_ZERO_ONE: 401,
    JWT_EXPIRED: 'jwt expired',
    INVALID_SIGNATURE: 'invalid signature',
    FOUR_ZERO_THREE: 403,
};
